import React, { useState } from "react";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

import TabPanel from "../../components/Tabs/TabPanel.component";
import AppPageHeader from "../../components/AppPageHeader";
import ModulesTab from "./ModulesTab";
import LicencesTab from "./LicencesTab";

const tabs = [
  {
    id: "modules",
    label: "Modules",
    icon: <ViewModuleIcon fontSize="small" />,
  },
  {
    id: "licences",
    label: "Licences & Users",
    icon: <VerifiedUserIcon fontSize="small" />,
  },
];

export default function LicencePage() {
  const [tab, setTab] = useState("modules");

  return (
    <Box sx={{ width: "100%", p: { xs: 2, md: 3 }, maxWidth: 1600, mx: "auto" }}>
      <AppPageHeader
        moduleKey="licences"
        title="Licence Management"
        subtitle="Which modules exist, and which users and licences can open them."
      />

      <Paper sx={{ overflow: "hidden" }}>
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          sx={{ px: 2 }}
        >
          {tabs.map((item) => (
            <Tab
              key={item.id}
              value={item.id}
              label={item.label}
              icon={item.icon}
              iconPosition="start"
            />
          ))}
        </Tabs>

        <TabPanel value={tab} index="modules">
          <ModulesTab />
        </TabPanel>
        <TabPanel value={tab} index="licences">
          <LicencesTab />
        </TabPanel>
      </Paper>
    </Box>
  );
}
